const LABELS: Record<string, string> = {
  pending: "pending", queued: "queued", running: "running", done: "done", failed: "failed", stale: "stale",
  blocked: "blocked", needs_human: "needs human", skipped: "skipped",
};

/** Step/job state as a text pill (never colour-only: the state is always in the text for bots and screen
 * readers; a custom label is followed by the state). `labelOnly`: the label already says everything (e.g. a kill
 * switch "on" / "off"); the state stays in `data-state` and the colour. */
export function StatusPill({ state, label, title, labelOnly = false }: {
  state: string | null | undefined;
  label?: string;
  title?: string;
  labelOnly?: boolean;
}) {
  const s = state ?? "pending";
  const stateText = LABELS[s] ?? s;
  return (
    <span className={`pill pill-${s}`} data-state={s} title={title}>
      {label ? (labelOnly ? label : `${label}: ${stateText}`) : stateText}
    </span>
  );
}
